<template>
  <div class="instant-quote-authorized">
    <div class="instant-quote-authorized--accepted" test-id="accepted">
      <div v-if="dateAuthorized" class="instant-quote-authorized--icon">
        <LsIcon type="checkmark" color="white" size="sm" />
      </div>
      <LsIcon v-else type="cancel" color="danger" size="sm" />

      <p v-if="dateAuthorized" class="instant-quote-authorized--text" test-id="accepted_text">
        You authorized this work on {{ dateAuthorized | date }}
      </p>
      <p v-else class="instant-quote-authorized--text" test-id="rejected_text">
        You turned down this work on {{ dateRejected | date }}
      </p>
    </div>
    <LsButton
      v-if="onboarding"
      text="save & continue"
      track-id="onboarding_services_view-save_and_continue"
      test-id="next"
      @click="next()"
    />
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { mapActions } from 'vuex';
import { LsIcon, LsButton } from '@/components/common';
import { ONBOARDING__GOTO_NEXT } from '@/store/types';

export default {
  name: 'InstantQuoteAuthorized',
  components: { LsIcon, LsButton },
  props: {
    dateAuthorized: VueTypes.string,
    dateRejected: VueTypes.string,
    onboarding: VueTypes.bool.def(false),
  },
  methods: {
    ...mapActions([ONBOARDING__GOTO_NEXT]),
    next() {
      this[ONBOARDING__GOTO_NEXT]();
    },
  },
};
</script>

<style lang="scss" scoped>
.instant-quote-authorized {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.instant-quote-authorized--accepted {
  padding-top: 20px;
  display: flex;
  align-items: center;
}

.instant-quote-authorized--icon {
  width: 36px;
  height: 36px;
  background-color: $primary;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.instant-quote-authorized--text {
  padding-left: 12px;
}

.instant-quote-authorized--continue {
  flex-direction: column;
}

@media (max-width: $mobile-max-width) {
  .instant-quote-authorized {
    flex-direction: column;
    align-items: flex-start;
  }
  .instant-quote-authorized--accepted {
    padding-bottom: 20px;
  }
}

.themed-app {
  .instant-quote-authorized--icon {
    background-color: $theme-color-primary;
  }
}
</style>
